import React from 'react'
import PayoutsContainer from 'containers/panel/reseller/payouts-container'
const PayoutsPage = () => {
  return (
    <PayoutsContainer/>
  )
}

export default PayoutsPage